'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { FooterSearchFallback } from './slots/FooterSearchFallback/FooterSearchFallback.js';

var defaultProps = {
    placeholder: "Поиск по сайту",
    renderSearchFallback: function() {
        return /*#__PURE__*/ jsx(FooterSearchFallback, {
            description: "Проверьте запрос и попробуйте ещё раз",
            title: "Ничего не найдено"
        });
    },
    defaultOpened: false
};

export { defaultProps };
